// extracted by mini-css-extract-plugin
export default {"date-holiday":"TimeLogsTable_date-holiday__24TeL","date-sunday":"TimeLogsTable_date-sunday__rAaAy"};